"use client";

import { useParams } from "next/navigation";
import { useAuth } from "@/contexts/AuthContext";
import { AbilitiesPageSkeleton } from "@/components/abilities/MarketplaceGrid";
import { PublicDetailView } from "@/components/marketplace/PublicDetailView";
import { SkillResumePage } from "@/components/SkillsPage/SkillResumePage";

export default function SkillDetailRoute() {
  const { slug } = useParams<{ slug: string }>();
  const { user, loading } = useAuth();

  if (loading) return <AbilitiesPageSkeleton />;
  if (!user) return <PublicDetailView type="skills" slug={slug} />;
  return <SkillResumePage slug={slug} />;
}
